import { controls, currencyToNumber, grouped } from "../../controls";

  const rpsl15 = {
  label: "Investment Credit Disbursement SLBC",
  starting: true,
  url: "rpsl15",
  pageLabel: "Investment Credit Disbursement SLBC",
  pageType: "history",
  // filteraction: true,
  filter: [


    ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Investment Credit Disbursement SLBC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    textReportProps: {
      'slbc': {
        filename: `Investment Credit Disbursement.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "State Code",
        accessor: "slbc_state_no",

      },

      {
        Header: "District Code",
        accessor: "slbc_district_no",

      },
      {
        Header: "Block Code",
        accessor: "slbc_block_code",
      },

      {
        Header: "KCCs for animal husbandry and allied activities A/C from 1st April to end of Current Quarter",
        accessor: "kccs_animal_husb_allied_activities_ac",

      },
      {
        Header: "KCCs for animal husbandry and allied activities Amount from 1st April to end of Current Quarter",
        accessor: "kccs_animal_husb_allied_activities_amt",
        type: "currency"
      },
      {
        Header: "Farm Production organistaion A/C from 1st April to end of Current Quarter",
        accessor: "farm_production_org_ac",

      },
      {
        Header: "Farm Production organistaion Amount from 1st April to end of Current Quarter",
        accessor: "farm_production_org_amt",
        type: "currency"
      },
      {
        Header: "Dairy Dev. A/C from 1st April to end of Current Quarter",
        accessor: "dairy_dev_ac",

      },
      {
        Header: "Dairy Dev. Amount from 1st April to end of Current Quarter",
        accessor: "dairy_dev_amt",
        type: "currency"
      },
      {
        Header: "Farm Mechanisation A/c from 1st April to end of Current Quarter",
        accessor: "farm_mechanisation_ac",

      },
      {
        Header: "Farm Mechanisation Amount from 1st April to end of Current Quarter",
        accessor: "farm_mechanisation_amt",
        type: "currency"
      },

      {
        Header: "Poultry A/C from 1st April to end of Current Quarter",
        accessor: "poultry_ac",

      },
      {
        Header: "Poultry Amt. from 1st April to end of Current Quarter",
        accessor: "poultry_amt",
        type: "currency"
      },
      {
        Header: "Fisheries. A/C from 1st April to end of Current Quarter",
        accessor: "fisheries_ac",

      },
      {
        Header: "Fisheries. Amount from 1st April to end of Current Quarter",
        accessor: "fisheries_amt",
        type: "currency"
      },
      {
        Header: "Rural Godown A/C from 1st April to end of Current Quarter",
        accessor: "rural_ac",

      },
      {
        Header: "Rural Godown Amount from 1st April to end of Current Quarter",
        accessor: "rural_amt",
        type: "currency"
      },
      {
        Header: "Agri Clinic A/C from 1st April to end of Current Quarter",
        accessor: "agri_clinic_ac",

      },
      {
        Header: "Agri Clinic Amt. from 1st April to end of Current Quarter",
        accessor: "agri_clinic_amt",
        type: "currency"
      },
      {
        Header: "Other A/c from 1st April to end of Current Quarter",
        accessor: "other_ac",

      },
      {
        Header: "Other Amount from 1st April to end of Current Quarter",
        accessor: "other_amt",
        type: "currency"
      },
    ]
  }
};

export default rpsl15;